import HouseholdModel, { HouseholdData, create as createHousehold } from "../models/HouseholdModel";
import { Commit } from "vuex";
import Vue from "vue";
import HouseholdMemberModel from "../models/HouseholdMemberModel";
import ApiService from "../lib/api";

interface HouseholdsState {
  households: { [id: number]: HouseholdModel };
  householdIds: number[];
  ownedIds: { [userId: number]: number[] };
}

interface Actions {
  commit: Commit;
}

const state: HouseholdsState = {
  households: {},
  householdIds: [],
  ownedIds: {},
};

const mutations = {
  add(state: HouseholdsState, household: HouseholdModel): void {
    if (state.householdIds.indexOf(household.data.id) === -1) {
      Vue.set(state.households, household.data.id, household);

      const owners = household.members.filter((m: HouseholdMemberModel) => m.data.role === 'owner');
      for (const owner of owners) {
        if (!state.ownedIds[owner.data.user_id]) {
          Vue.set(state.ownedIds, owner.data.user_id, []);
        }

        state.ownedIds[owner.data.user_id].push(household.data.id);
      }

      state.householdIds.push(household.data.id);
    }
  }
};

const actions = {
  fetchOwned({commit}: Actions): Promise<any> {
    return new Promise((resolve, reject) => {
      ApiService.get('/households/owned').then((resp: ApiResponseArray<HouseholdData>) => {
        for (const h of resp.data) {
          commit('add', createHousehold(h));
        }
        resolve();
      }).catch(reject);
    });
  },
  create({commit}: Actions, payload: HouseholdModel): Promise<any> {
    return new Promise((resolve, reject) => {
      ApiService.post('/households', payload.data as unknown as Record<string, unknown>).then((resp: ApiResponseSingle<HouseholdData>) => {
        commit('add', createHousehold(resp.data));
        resolve();
      }).catch(reject);
    });
  }
};

const getters = {
  owned: (state: HouseholdsState) => (userId: number) => {
    return state.ownedIds[userId] ? state.ownedIds[userId].map((id) => state.households[id]) : [];
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
